import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';

const SivagiriPilgrimagePage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };
  return (
    <div className="bio-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Hero Image */}
      <div className="bio-hero-image">
        <img src="/Sndp/Sivagiri_Ashramam_at_Varkkala-scaled.jpg" alt="Sivagiri Ashramam at Varkkala" />
      </div>

      {/* Page Title */}
      <div className="bio-page-title">
        <h1>History of Sivagiri Pilgrimage</h1>
        <div className="bio-title-bar"></div>
      </div>

      {/* Main Content */}
      <div className="bio-content">

        <div className="bio-section-heading">
          <span>History of Sivagiri Pilgrimage</span>
        </div>

        <p className="bio-text">
          At the beginning of 1928 while the Sree Narayana Guru was camping at Nagampadam temple at Kottayam,
          a couple of his ardent disciples – Vallabhasseri Govindan Vaidyan and Kittan writer – hesitantly mooted
          the idea of "Pilgrimage to Sivagiri". Swamiji enquired them about the object of the pilgrimage but they
          couldn't reply. Hence the Guru himself explained that the aim of Theerthadana (pilgrimage) must be for
          the creation of a comprehensive knowledge among the people for their overall development and prosperity
          and suggested certain norms to be observed. The pilgrims should reach Sivagiri in yellow garb as the
          symbol of devotees, after following a brief ten day austerity based on Sree Budha's five purities of
          Body, Word, Mind, Food and Deed. Guru underlined the need for education, cultural and moral purity for
          the yearly meet. January 1, the new year day was suggested for the Pilgrimage and it should be so planned
          to focus attention on eight subjects – Education, Cleanliness, Piety, Organised Endeavour, Agriculture,
          Trade, Handicrafts and Technical Training. Experts on these subjects should be invited to lecture on them
          and the pilgrims should listen attentively. What they have heard should be practised in the day to day
          life which will lead them to prosperity. The Guru concluded that this should be the main goal of the
          pilgrimage to Sivagiri.
        </p>

        <div className="bio-quote-box">
          <p>"One Caste, One Religion, One God for Man"</p>
          <p>"One in Kind, One in Faith and One in God is Man"</p>
          <p>"Of One womb, Of One Form, Difference therein None"</p>
          <p>"Whatever be the Religion The Man must be good"</p>
          <p>"Freedom through Education Strength through Organisation"</p>
          <p>May the Gurudev bless us always.</p>
        </div>

      </div>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SivagiriPilgrimagePage;
